// extracted by mini-css-extract-plugin
module.exports = {"collapseBtn":"TradingAddress_collapseBtn__3RVhO"};